import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

interface Crumb {
  label: string;
  href?: string;
}

export default function Breadcrumbs({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav className="hidden sm:flex items-center gap-1 text-sm text-text-secondary mb-4">
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight size={14} className="text-text-secondary/50 flex-shrink-0" />}
            {crumb.href && !isLast ? (
              <Link href={crumb.href} className="hover:text-brand transition-colors">
                {crumb.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-text-primary font-medium' : ''}>
                {crumb.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
